<template>
  <busstop-select v-model="selected" isEnableAttribute="enableBoarding" :setDefaultBusstop="setDefaultBusstop" />
</template>

<script>
import BusstopSelect from './TentativeBusstopSelect'

export default {
  components: {
    BusstopSelect
  },
  computed: {
    selected: {
      get () {
        const departure = this.$store.getters['reservation/getDeparture']
        return departure
      },
      set (busstop) {
        this.$store.dispatch('reservation/selectDeparture', busstop)
      }
    }
  },
  methods: {
    setDefaultBusstop: function (busstop) {
      this.$store.dispatch('reservation/selectDeparture', busstop)
    }
  }
}
</script>
